import React from 'react';
import { OtoOffer } from './pages/OtoOffer';
export function App() {
  return <div className="w-full min-h-full" style={{
    backgroundColor: '#0a0a0a'
  }} data-id="element-0">
      <OtoOffer data-id="element-1" />
    </div>;
}